export default __webpack_public_path__ + "static/media/blocked 1.77ab1ad5.svg";